import React from 'react';
import { Instructions } from './Instructions';

import { Popover } from './Popover';
import { withInteractiveStore } from './TemplateWithInteractiveStore';

const HotspotWithoutStore = ({assets, interactive, ...props}) => {
  const {accentColor,bg,bgPattern,headingColor,popoverHeadingSize,hotspots,id,popoverHeadingStyle,title} = interactive;
  const showInstructions = props.forwardedRef ? true : false;

  const getClasses = () => {
    let classes = ['dinfos-hotspot'];
    // not implemented yet
    // if (xlHeight) {
    //   classes.push(`dinfos-hotspot--xl-height`)
    // }
    if (headingColor !== 'navy') {
      classes.push(`dinfos-hotspot--black-headline`)
    }
    if (bgPattern) {
      classes.push(`dinfos-hotspot--bg-${bgPattern}`)
    }
    if (popoverHeadingSize) {
      classes.push(`dinfos-hotspot--headlines-${popoverHeadingSize}`)
    }
    if (popoverHeadingStyle) {
      classes.push(`dinfos-hotspot--${popoverHeadingStyle}`)
    }
    return classes.join(' ');
  }
  
  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <div className="dinfos-intv__wrapper">  
        <section className={`${getClasses()} ${showInstructions ? 'overflow-hidden' : ''}`} data-intv id={id} data-theme={accentColor}>

          <Instructions hide={!showInstructions} instructions="Click a target to reveal more in-depth information." id={`${id}-instr`} />

          <h2 className="sr-only">{title}</h2>
          
            
            
              <div className="dinfos-hotspot__image-wrapper">

                { bg && bg.src 
                  ? <img src={assets[bg.src]} alt={bg.alt} className="dinfos-hotspot__image" data-src={bg.src} />
                  : <div style={{height: 200, width: '100%'}}></div> // placeholder
                }

                <div className="dinfos-hotspot__overlay d-none"></div>
                
                {hotspots ? 

                  hotspots.map((spot, index) => (

                    <React.Fragment key={index}>

                      <button 
                        className={`btn dinfos-btn dinfos-hotspot__spot ${spot.alternate_icon ? 'dinfos-hotspot__spot--alt' : ''}`} 
                        aria-label={spot.label} 
                        type="button" aria-expanded="false" 
                        aria-controls={`${id}-popover-${index}`} 
                        style={{
                          left:spot.left + '%',
                          top:spot.top + '%'
                        }}
                      >
                        { spot.alternate_icon ? 
                          <i className={`fas fa-${spot.alternate_icon}`}></i>
                          :
                          <i className="fas fa-plus"></i>
                        } 
                      </button>

                      { spot.popover ? 
                        <Popover 
                          id={id} 
                          assets={assets} 
                          autoNumber={popoverHeadingStyle === 'numbered'} 
                          index={index} 
                          top={spot.top} 
                          left={spot.left}
                          {...spot.popover}
                        />
                      : '' }

                    </React.Fragment>
                  
                  ))

                : ''} {/* End hotspots condition */}
                  
              </div>

        </section>
        
      </div>
    </div>
  )

}


export const Hotspot = withInteractiveStore(
  HotspotWithoutStore,
);